import axios from "axios";

const instance = axios.create({
    baseURL: "https://us-central1-totalserviceweb.cloudfunctions.net/api"
});


export default instance;